import {clx, TextMedium, TextRegular, TextSemiBold} from '@hm/fundamental'
import {GenericComponentProps} from '@hm/fundamental/dist/types'

interface CheckBoxProps extends React.AllHTMLAttributes<HTMLInputElement>, GenericComponentProps {
  label?: string
  subLabel?: string
}

// This component will eventually be replaced by the one from @hm/fundamental
// https://jira.heidelbergcement.com/browse/HCP-95055
export const CheckBox: React.FC<CheckBoxProps> = ({
  label,
  subLabel,
  className,
  'data-cy': dataId,
  children,
  ...props
}) => {
  return (
    <label className={clx('flex gap-2 cursor-pointer', className)} data-cy={dataId}>
      <div className="relative flex items-center">
        <input {...props} type="checkbox" className="fundamental-checkbox size-4" />
      </div>
      {children ? (
        children
      ) : (
        <>
          {label && !subLabel && <TextMedium className="text-foreground">{label}</TextMedium>}
          {label && subLabel && (
            <div>
              <div>
                <TextSemiBold className="text-foreground">{label}</TextSemiBold>
              </div>
              <div>
                <TextRegular className="text-foreground_faded">{subLabel}</TextRegular>
              </div>
            </div>
          )}
        </>
      )}
    </label>
  )
}
